import { Image } from '@mantine/core'
import { forwardRef, useEffect, useState } from 'react'
import type { Props } from '../node/definition'
import IconSvg from '@packages/icon-svg'

export default forwardRef((p: Props) => {
	const {
		source,
		fallbackSrc,
		width,
		height,
		radius,
		placeholder,
		placeholderIconSize,
		customProps,
		style,
		fit,
		...rest
	} = p

	const shouldShowPlaceholderOnly = !source && placeholder

	const [imgSrc, setImgSrc] = useState(source)
	// Обновляем, если проп source поменялся
	useEffect(() => {
		setImgSrc(source)
	}, [source])
	if (shouldShowPlaceholderOnly) {
		// const IconPhoto = R.libs.icons.IconPhoto
		return <IconSvg iconName='photo' iconSize='24' iconColor='gray' iconStroke='2' />
		// return <IconPhoto size={placeholderIconSize} color='gray' />
	}

	if (!imgSrc) return null
	return (
		<Image
			src={imgSrc}
			radius={radius}
			fit={fit}
			onError={() => {
				if (fallbackSrc && imgSrc !== fallbackSrc) {
					setImgSrc(fallbackSrc)
				}
			}}
			
			style={{ width, height, ...style }}

			{...customProps}
			{...rest}
		/>
	)
})
